import React, { useState } from 'react';
import { VIEW_PRINT, VIEW_PRINT_DOWNLOAD } from '../lib/media';

const OPTIONS = [
  {
    value: VIEW_PRINT,
    icon: '🔒',
    title: 'View & Print only',
    body: "They can open and print it, but can't download or save it.",
  },
  {
    value: VIEW_PRINT_DOWNLOAD,
    icon: '⬇',
    title: 'View, Print & Download',
    body: 'They can open, print and save a copy.',
  },
];

// Shown before sending a photo / video / document. Nothing is preselected —
// the sender must pick one. onConfirm(permission) sends; onCancel aborts.
export default function PermissionDialog({ file, onConfirm, onCancel }) {
  const [choice, setChoice] = useState(null);
  if (!file) return null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black/40 grid place-items-center p-4"
      onClick={onCancel}
    >
      <div
        className="w-full max-w-md bg-white rounded-2xl shadow-xl p-5"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="perm-title"
      >
        <h2 id="perm-title" className="text-lg font-semibold text-ink">
          What can the receiver do?
        </h2>
        <p className="text-sm text-muted truncate mt-0.5">Sending {file.name}</p>

        <div className="mt-4 space-y-2">
          {OPTIONS.map((o) => {
            const selected = choice === o.value;
            return (
              <button
                key={o.value}
                type="button"
                onClick={() => setChoice(o.value)}
                className={`w-full text-left flex items-start gap-3 p-3 rounded-xl border transition-colors ${
                  selected
                    ? 'border-brand bg-brand/5 ring-1 ring-brand'
                    : 'border-slate-200 hover:bg-slate-50'
                }`}
              >
                <span className="w-9 h-9 shrink-0 rounded-lg bg-brand/10 grid place-items-center">
                  {o.icon}
                </span>
                <span className="flex-1">
                  <span className="block font-medium text-ink">{o.title}</span>
                  <span className="block text-xs text-muted mt-0.5">{o.body}</span>
                </span>
                <span
                  className={`mt-1 w-4 h-4 shrink-0 rounded-full border-2 ${
                    selected ? 'border-brand bg-brand' : 'border-slate-300'
                  }`}
                />
              </button>
            );
          })}
        </div>

        <div className="mt-5 flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 rounded-full text-sm text-muted hover:bg-slate-100"
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={!choice}
            onClick={() => onConfirm(choice)}
            className="px-5 py-2 rounded-full text-sm bg-brand text-white hover:bg-brand-dark disabled:opacity-40"
          >
            Send ➤
          </button>
        </div>
      </div>
    </div>
  );
}
